import { Input } from 'antd';

import { getRandomId } from '../../../../../../utilities/randomId';
import { getAsNumber } from '../../../../../../utilities/numberConvertion';

export const TableCol = (handleSave) => {
  return [
    {
      key: getRandomId(),
      dataIndex: 'apa',
      title: 'APA Area',
      render: (value) =>
        value?.area ? (
          <div>
            <div style={{ fontWeight: 500 }}>{value.area}</div>
            {value?.scoringMethod && (
              <div style={{ color: '#888', marginTop: 4 }}>
                {`(${value.scoringMethod})`}
              </div>
            )}
          </div>
        ) : null,
    },
    {
      key: 'semester1',
      dataIndex: 'semester1',
      title: 'Spring',
      render: (value, row) => (
        <Input
          placeholder="Enter Count"
          value={value?.count}
          onChange={(e) =>
            handleSave({
              ...row,
              semester1: {
                ...row.semester1,
                count: getAsNumber(e.target.value)
              }
            })
          }
        />
      )
    },
    {
      key: 'semester2',
      dataIndex: 'semester2',
      title: 'Summer',
      render: (value, row) => (
        <Input
          placeholder="Enter Count"
          value={value?.count}
          onChange={(e) =>
            handleSave({
              ...row,
              semester2: {
                ...row.semester2,
                count: getAsNumber(e.target.value)
              }
            })
          }
        />
      )
    },
    {
      key: 'semester3',
      dataIndex: 'semester3',
      title: 'Autumn',
      render: (value, row) => (
        <Input
          placeholder="Enter Count"
          value={value?.count}
          onChange={(e) =>
            handleSave({
              ...row,
              semester3: {
                ...row.semester3,
                count: getAsNumber(e.target.value)
              }
            })
          }
        />
      )
    }
  ];
};
